import React from 'react';
import { MdOutlineCurrencyExchange } from 'react-icons/md';
import dayjs from 'dayjs';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import {
  GuestEntryDto,
  GuestEntryTier,
  GuestEntryUser
} from 'legacy/tickets/types';
import { currencyFormat } from 'legacy/common/utils/currency';

interface TicketDetailsProps {
  data: GuestEntryDto;
  isOrganizer: boolean;
  onRefundTicket: (params: {
    ticketId: string;
    tierData: GuestEntryTier;
    purchaser: GuestEntryUser;
  }) => void;
}

const TicketDetails: React.FC<TicketDetailsProps> = ({
  data,
  onRefundTicket,
  isOrganizer
}) => {
  const onRefundTicketClick = () => {
    onRefundTicket({
      ticketId: data.id,
      tierData: data.tier,
      purchaser: data.purchaser
    });
  };

  return (
    <div className="p-6 flex justify-center flex-col">
      <div className="border-b-1 border-gray-100" />
      <div className="text-xl pt-5 pb-2 flex justify-center">
        <img src="/img/icons/ticket-admit-one.svg" />
      </div>
      {data?.bundleProductName && (
        <p className="overflow-hidden text-ellipsis whitespace-nowrap text-lg text-center">
          <span className="font-semibold">Bundle: </span>
          {data?.bundleProductName}
        </p>
      )}
      <p className="overflow-hidden text-ellipsis whitespace-nowrap text-lg text-center pb-4 ">
        <span className="font-semibold">Ticket: </span>
        {data?.tier?.name}
      </p>
      {data.type === 'ticket' ? (
        <>
          {!data.bundleProductId ? (
            <p className="text-lg pb-4 text-center font-normal">
              {currencyFormat(data?.amountPaid)}
            </p>
          ) : (
            <p className="text-lg pb-4 text-center font-normal text-gray-500 text-sm italic">
              Purchased as part of a bundle
            </p>
          )}
          <p className="text-sm font-normal pb-1 text-center">
            Purchased by{' '}
            <span className="font-semibold">
              {data.purchaser.firstName} {data.purchaser.lastName}
            </span>
          </p>
          <p className="text-sm font-normal pb-1 text-center">
            Purchased on{' '}
            <span className="font-semibold">
              {dayjs(data?.purchasedAt).format('MMM D, YYYY | h:mma')}
            </span>
          </p>
          {data?.discountCode && (
            <p className="text-sm font-normal pb-1 text-center">
              Special code{' '}
              <span className="font-semibold">{data?.discountCode}</span>
            </p>
          )}
          {data?.trackingLink && (
            <p className="text-sm font-normal pb-1 text-center">
              Tracking link{' '}
              <span className="font-semibold">{data?.trackingLink}</span>
            </p>
          )}
        </>
      ) : (
        <>
          <p className="text-sm font-normal pb-1 text-center">
            Created by{' '}
            <span className="font-semibold">
              {data?.createdBy?.firstName} {data?.createdBy?.lastName}
            </span>
          </p>
          <p className="text-sm font-normal pb-1 text-center">
            Created on{' '}
            <span className="font-semibold">
              {dayjs(data?.createdAt).format('MMM D, YYYY | h:mma')}
            </span>
          </p>
        </>
      )}
      {data.type !== 'complimentary' && isOrganizer && (
        <div className="flex justify-center pt-3">
          <Button
            onClick={onRefundTicketClick}
            autoWidth
            type={ButtonType.Danger}
            icon={<MdOutlineCurrencyExchange />}
          >
            {data.bundleProductId ? 'Refund Bundle' : 'Refund Ticket'}
          </Button>
        </div>
      )}
      <div className="border-b-1 border-gray-100 pt-6" />
    </div>
  );
};

export default TicketDetails;
